import CardTemplate from "components/card/card-template/CardTemplate";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

const UncompletedApplicationExpiredCard = () => {
    const navigate = useNavigate();

    const handleNewApplication = () => {
        navigate(ROUTES.INVITATION);
    };

    return (
        <CardTemplate className="text-base-content min-h-[256px] tablet:min-h-[256px]" title="Your Application is Expired">
            <div
                data-testid="uncompleted-application-expired-content"
                className="font-medium text-base-content text-base flex flex-col gap-5 pt-1"
            >
                <p className="text-base text-md leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                    For security reasons, saved applications expire after 10 days.
                </p>
                <p className="text-sm leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                    You can start a new application at any time.
                </p>
                <div className="flex justify-center">
                    <button
                        data-testid="new-application-button"
                        type="button"
                        onClick={handleNewApplication}
                        className="btn btn-primary w-[169px] h-[36px] text-white"
                    >
                        New Application
                    </button>
                </div>
            </div>
        </CardTemplate>
    );
};

export default UncompletedApplicationExpiredCard;
